import styled, {ThemeProps} from 'styled-components';

import {Theme} from '../../../../../theme/types';

export const AutocompleteWrapperStyles = styled.div(
  (props: ThemeProps<Theme>) => `
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`,
);

export const SearchInputStyles = styled.input(
  (props: ThemeProps<Theme>) => `
  background-color: ${props.theme.colors.goBrandBlue.dark};
  color: white;
  border: none;
  font-size: ${props.theme.font.custom(16)};
  font-family: ${props.theme.font.fontFamily};
  font-weight: bold;
  text-transform: capitalize;

  display: block;
  width: 100%;
  height: 4.2rem;
  padding: ${props.theme.spacing.base} ${props.theme.spacing.base} ${props.theme.spacing.custom(
    12,
  )} ${props.theme.spacing.base};
    line-height: 1.3;
    border-radius: ${props.theme.misc.borderRadius.xlarge};
    flex-direction: row;
    align-items: center;
    justify-conent: center;
    &::-webkit-input-placeholder{
      color: white;
      opacity: 0.5;
      ${SearchInputStyles}.font-size;
      ${SearchInputStyles}.font-family;
      ${SearchInputStyles}.font-weight;
    }
    &:focus{
      box-shadow: none;
      outline: none;
    }
`,
);

export const SearchLabelStyles = styled.label(
  (props: ThemeProps<Theme>) => `
  color: ${props.theme.colors.goWhite.base};
  padding-bottom: ${props.theme.spacing.small};
  padding-left: ${props.theme.spacing.custom(2)};
`,
);
